import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  TextField,
  Grid,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormControlLabel,
  FormGroup,
  Checkbox,
} from '@material-ui/core';
import { createBccUserAsync } from './bccUserStore/bccUserStoreSlice';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { sendMessageAsync } from '../../common/CommonStore/CommonStoreSlice';

function addUser() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [contact, setContact] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState([]);

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const add = async () => {
    if (contact.length === 10) {
      try {
        let payload = {
          name: name,
          email: email,
          password: password,
          contact: contact,
          role: role,
        };
        dispatch(createBccUserAsync(payload))
          .unwrap()
          .then((res) => {
            toast.success(`User ${res.email} was successfully created.`);
            dispatch(
              sendMessageAsync({
                to: email,
                subject: 'You have been invited to BCC!',
                htmlBody: `
      <div style="background-color:#ffffff;padding:16px;">
      <div style="text-align:center">
        <a href="#"><img style="width:150px;" src="https://buzzapp.tech/assets/1.png"></a>
      </div>
      <div style="padding-top:16px;">Hi ${name},</div><br/>
      <div style="padding-top:16px;">You have been invited by an Admin to join ${role} account on Buzzapp Control Centre (BCC)!</div>
      <div style="padding-top:16px;">Use the following credentials to log into to BCC account:</div>
      <div style="padding-top:16px;">URL: <a href="https://bcc.buzzapp.tech/" target="_blank">https://bcc.buzzapp.tech/</a></div>
      <div style="padding-top:2px;">Username: ${email}</div>
			<div style="padding-top:2px;">password: ${password}</div>
      <div style="padding-top:16px;">Regards,<br/>Team Buzzapp</div>
      </div>
      `,
              })
            )
              .unwrap()
              .then((res) => {});
            history.push('/user-management/bcc-user');
            // window.location.reload(false);
          })
          .catch((err) => toast.error('please enter valid data!'));
      } catch (error) {
        toast.error('Creating user failed, please try again in some time!');
      }
    } else {
      toast.error('Phone number should be 10 digits only!');
    }
  };

  const handleRoleSelection = (key) => {
    console.log(key, role);
    if (role.includes(key)) {
      console.log(1);
      const newRoleArr = role.filter((item) => item !== key);
      setRole(newRoleArr);
    } else {
      console.log(2);
      setRole([...role, key]);
    }
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <Box border="1px solid #dfdfdf" p={3}>
            <Box mb={3} fontSize={22} fontWeight={'fontWeightSmall'}>
              Employee
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <lable>Employee Name</lable>
                <TextField
                  placeholder="Employee Name"
                  variant="outlined"
                  fullWidth
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <lable>Contact</lable>
                <TextField
                  type="number"
                  placeholder="Contact Number"
                  variant="outlined"
                  fullWidth
                  value={contact}
                  onChange={(e) => setContact(e.target.value)}
                />
              </Grid>
            </Grid>
            <Box mt={2} />
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <lable>Email</lable>
                <TextField
                  type="email"
                  placeholder="Your Email"
                  variant="outlined"
                  fullWidth
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <lable>Password</lable>
                <OutlinedInput
                  type={showPassword ? 'text' : 'password'}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
            </Grid>
            <Box mt={2} />
            <Grid container spacing={2}>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={
                    name === '' ||
                    contact === '' ||
                    email === '' ||
                    password === '' ||
                    role === ''
                  }
                  onClick={add}>
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box border="1px solid #dfdfdf" p={0.4}>
            <Box
              bgcolor="#FFF6F2"
              fontSize={18}
              fontWeight={500}
              p={1}
              pl={2}
              pt={2}
              pb={2}>
              Manage employee access
            </Box>
            <FormControl component="fieldset" style={{ padding: '1rem' }}>
              <FormGroup>
                {[
                  { value: 'bccSchoolAdmin', label: 'BCC School Admin' },
                  { value: 'bccDiscoveryAdmin', label: 'BCC Discovery Admin' },
                  { value: 'bccAtheneumAdmin', label: 'BCC Atheneum Admin' },
                  { value: 'bccAkademyAdmin', label: 'BCC Akadmy Admin' },
                  { value: 'bccAffiliateAdmin', label: 'BCC Affiliate Admin' },
                  {
                    value: 'bccTeenybeansAdmin',
                    label: 'BCC Teeny Beans Admin',
                  },
                  {
                    value: 'saleshubUser',
                    label: 'Saleshub User',
                  },
                ].map((item) => {
                  return (
                    <FormControlLabel
                      key={item.value}
                      control={
                        <Checkbox
                          checked={role.includes(item.value)}
                          onChange={() => handleRoleSelection(item.value)}
                          name={item.value}
                        />
                      }
                      label={item.label}
                    />
                  );
                })}
              </FormGroup>
            </FormControl>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default addUser;
